import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const rapidboardUserReportRoute: InvariantJiraRoute = {
	name: 'rapidboard-user-report',
	path: '/jira/people/:accountId/boards/:boardId/reports/:chartView',
};
